/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-closing-tag-location*/
import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import { withTranslation } from 'react-i18next';

import { commonStyle } from '../Common/CommonStyle';

import { CommaSeparator } from '../../AppUtil/AppUtil';

import ModalDisclaimer from '../Common/Profile/ModalDisclaimer';
import ModalFooter from '../Common/Profile/ModalFooter';
import ModalHelp from '../Common/Profile/ModalHelp';
import DisclaimerIcon from '../Common/Profile/SvgIcon/DisclaimerIcon';
import InclaimationIcon from '../Common/Profile/SvgIcon/InclaimationIcon';
import NeedHelpIcon from '../Common/Profile/SvgIcon/NeedHelpIcon';
import QuestionIcon from '../Common/Profile/SvgIcon/QuestionIcon';
import './style.css';
import UserBalanceHeader from './UserBalanceHeader';
import UserService from '../../Service/UserService';

class Main extends Component {
	constructor(props) {
		super(props);
		this.state = {
			_loading: false,
			_error: '',
			users: {},
			_currentNav: { content: 'LEND', color: '#76C4EE' }
		};
	}

	updateBalance = async () => {
		this.setState({ _loading: true });
		try {
			const users = await UserService.getKycStatus({
				id: this.props.currentUser.profile.id,
				action: 'SUBMIT_KYC'
			});
			if (users) {
				this.setState({ users: users.item, _loading: false });
			}
		} catch (error) {
			this.setState({ _loading: false });
			console.log(error);
		}
	};

	componentDidMount() {
		const error = localStorage.getItem('error');

		if (error) {
			this.setState({ _error: error });
		} else {
			this.updateBalance();
		}
	}

	handleCurrentNav = nav => {
		this.setState({
			_currentNav: nav
		});
	};

	detectLoanTypeHandler = e => {
		const { _currentNav } = this.state;
		// const tableType = (_currentNav.content === 'LEND' && e.label.toLowerCase() === 'requests') ? 'BORROW' : _currentNav.content;
		const type = {
			openType: 'LIST',
			tableType: _currentNav.content,
			userType: _currentNav.content !== 'GUARANTOR' ? 'USER' : 'GUARANTOR',
			label: e.label,
			description: e.description,
			tableColor: _currentNav.color
		};
		this.props.detectLoanType(type);
	};

	setTypeModal = e => {
		this.setState({
			_typeModal: e
		});
	};

	setIsModalOpen = () => {
		this.setState({
			_isModalOpen: !this.state._isModalOpen
		});
	};

	render() {
		const Footer = () => {
			return (
				<>
					<div className="dashboard-landing-footer">
						<DisclaimerIcon
							onClick={() => {
								this.setTypeModal('disclaimer');
								this.setIsModalOpen();
							}}
						/>
						<NeedHelpIcon
							onClick={() => {
								this.setTypeModal('needhelp');
								this.setIsModalOpen();
							}}
						/>
					</div>

					<ModalFooter
						content={
							this.state._typeModal === 'disclaimer' ? (
								<ModalDisclaimer icon={<InclaimationIcon />} />
							) : (
								<ModalHelp
									email="contact@lendami.com.ph"
									icon={<QuestionIcon />}
									number="+639176544580"
								/>
							)
						}
						open={this.state._isModalOpen}
						setIsModalOpen={this.setIsModalOpen}
						typeModal={this.state._typeModal}
					/>
				</>
			);
		};
		const { classes, currentUser } = this.props;
		const { t } = this.props;
		let user = currentUser.attributes.name;
		user = user
			.split(' ')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
		const currentNav = this.state._currentNav.content.toLowerCase();

		const sampleDataTop = [
			{
				label: 'Offers',
				value:
					currentNav == 'lend'
						? this.props.lendPendingOffers.length
						: currentNav == 'borrow'
						? this.props.borrowPendingOffers.length
						: null,
				description: currentNav == 'lend' ? 'waiting to be accepted' : 'you need to approve/decline'
			},
			{
				label: 'Requests',
				value:
					currentNav == 'lend'
						? // ? this.props.lendPendingRequests.length
						  this.props.lendPending || 0
						: currentNav == 'borrow'
						? this.props.borrowPendingRequests.length
						: this.props.guarantorPending,
				description: currentNav == 'lend' ? 'you need to approve/decline' : 'waiting to be accepted'
			},
			{
				label: 'Modified',
				value:
					currentNav == 'lend'
						? this.props.lendModify
						: currentNav == 'borrow'
						? this.props.borrowModify
						: null,
				description: 'loans you need to review'
			}
		];
		const sampleDataBottom = [
			{
				label: 'Active',
				value:
					currentNav == 'lend'
						? this.props.lendAccept
						: currentNav == 'borrow'
						? this.props.borrowAccept
						: this.props.guarantorAccept,
				description: 'loans'
			},
			{
				label: 'Declined',
				value:
					currentNav == 'lend'
						? this.props.lendDecline
						: currentNav == 'borrow'
						? this.props.borrowDecline
						: this.props.guarantorDecline,
				description: 'offers/requests'
			},
			{
				label: 'Completed',
				value:
					currentNav == 'lend'
						? this.props.lendComplete
						: currentNav == 'borrow'
						? this.props.borrowComplete
						: this.props.guarantorComplete,
				description: 'loans'
			},
			{
				label: 'Paused',
				value:
					currentNav == 'lend'
						? this.props.lendPaused
						: currentNav == 'borrow'
						? this.props.borrowPaused
						: null,
				description: 'loans you may resume'
			}
		];

		const Item = ({ data }) => {
			return (
				<div className="dashboard-box-item" style={{ cursor: 'pointer' }}>
					<div>{CommaSeparator(data.value)}</div>
					<div
						className="dashboard-decription-container"
						onClick={() => {
							this.detectLoanTypeHandler({
								label: data.label,
								description: data.description
							});
						}}>
						<div>{data.label}</div>
						<div>{data.description}</div>
					</div>
				</div>
			);
		};

		return (
			<div>
				<UserBalanceHeader
					error={this.state._error}
					classContainer="dashboard-welcome-wrapper"
					user={user}
					balance={this.state.users?.wallet_balance || 0}
				/>
				<div className="dashbaord-tabs-wrapper">
					<div className="dashboard-tabs">
						<nav
							className="on-hover-cursor-pointer"
							id="dashboard-nav-lender"
							onClick={() => this.handleCurrentNav({ content: 'LEND', color: '#76C4EE' })}>
							{t('label.lend')}er
						</nav>
						<nav
							className="on-hover-cursor-pointer"
							id="dashboard-nav-borrower"
							onClick={() => this.handleCurrentNav({ content: 'BORROW', color: '#FFC63C' })}>
							{t('label.borrow')}er
						</nav>
						<nav
							className="on-hover-cursor-pointer"
							id="dashboard-nav-guarantor"
							onClick={() =>
								this.handleCurrentNav({
									content: 'GUARANTOR',
									color: '#25B78D'
								})
							}>
							{t('label.guarantor')}
						</nav>
					</div>
				</div>

				{this.state._currentNav.content !== 'GUARANTOR' ? (
					<div className="dashboard-box-container" style={{ backgroundColor: this.state._currentNav.color }}>
						<div className="dashboard-box">
							<img
								src={process.env.PUBLIC_URL + 'images/exclamation-mark-black.svg'}
								className="abs-exclamation"
							/>
							{sampleDataTop.map((data, index) => {
								if (this.state._currentNav.content !== 'GUARANTOR') {
									return <Item data={data} key={index} />;
								} else {
									if (
										data.label.toLowerCase() === 'offers' ||
										data.label.toLowerCase() === 'modified'
									) {
										return null;
									}
									return <Item data={data} key={index} />;
								}
							})}
						</div>
						<div className="dashboard-box">
							{sampleDataBottom.map((data, index) => {
								if (this.state._currentNav.content !== 'GUARANTOR') {
									return <Item data={data} key={index} />;
								} else {
									if (
										data.label.toLowerCase() === 'offers' ||
										data.label.toLowerCase() === 'modified' ||
										data.label.toLowerCase() === 'paused'
									) {
										return null;
									}
									return <Item data={data} key={index} />;
								}
							})}
						</div>
					</div>
				) : (
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							height: '510px'
						}}>
						<h1 style={{ fontSize: '40px', marginTop: '60px', color: 'white', fontWeight: 'bolder' }}>
							Coming Soon
						</h1>
					</div>
				)}

				<div className="footer-icons" id="form-opacity-none">
					<Footer />
				</div>
			</div>
		);
	}
}

export default withStyles(commonStyle)(withTranslation()(Main));
